module.exports = __webpack_public_path__ + "static/media/aus_flag_2.08b24c75.png";